import { useField, Field } from 'vee-validate';


export default {
  __name: 'ExperiencedPainTextField',
  setup(__props, { expose }) {
  expose();

const { value, errors, errorMessage } = useField('experiencedPain');

const __returned__ = { value, errors, errorMessage, get useField() { return useField }, get Field() { return Field } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}